import React from 'react';
import styles from '../StoreGuide.module.scss';
import SupportEmailLink from '../../../components/SupportEmailLink/SupportEmailLink';
import DiscordInviteButton from '../../../components/DiscordInviteButton/DiscordInviteButton';

const EpicGamesGuide: React.FC = () => {
  return (
    <div className={styles.guideContent}>
      <div className={styles.guideHeader}>
        <img 
          src={`${process.env.PUBLIC_URL}/images/activation-guides/Epic_Games2.png`}
          alt="Epic Games"
          className={styles.storeLogo}
          onError={(e) => {
            const target = e.currentTarget;
            target.onerror = null;
            target.style.display = 'none';
          }}
        />
        <div className={styles.storeTitle}>
          <h1>Product key activation on Epic Games</h1>
          <p>Activate your Epic Games keys through the website or application</p>
        </div>
      </div>

      <div className={styles.stepsContainer}>
        
        {/* Website Method */}
        <div className={styles.methodSection}>
          <h2 className={styles.methodTitle}>Via Website:</h2>
          <div className={styles.steps}>
            
            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>1</span>
              </div>
              <div className={styles.stepContent}>
                <h3 className={styles.stepTitle}>Visit Epic Games Website</h3>
                <div className={styles.stepDescription}>
                  Visit{' '}
                  <a 
                    href="https://www.epicgames.com/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className={styles.inlineLink}
                  >
                    epicgames.com
                  </a>
                  {' '}and sign into your Epic Games account or create a new account if this is the first game you activate in this platform.
                </div>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>2</span>
              </div>
              <div className={styles.stepContent}>
                <h3 className={styles.stepTitle}>Access Redeem Page</h3>
                <div className={styles.stepDescription}>
                  Once you're logged in, use this link to activate your game.
                </div>
                <div className={styles.stepImage}>
                  <img 
                    src={`${process.env.PUBLIC_URL}/images/activation-guides/epic-games-website-step-2.jpg`}
                    alt="Step 2: Access redeem page"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.onerror = null;
                      target.style.display = 'none';
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>3</span>
              </div>
              <div className={styles.stepContent}>
                <h3 className={styles.stepTitle}>Enter Key and Redeem</h3>
                <div className={styles.stepDescription}>
                  Enter your key and click <strong className={styles.boldText}>"REDEEM"</strong>.
                </div>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>4</span>
              </div>
              <div className={styles.stepContent}>
                <h3 className={styles.stepTitle}>OnePlay Support</h3>
                <div className={styles.stepDescription}>
                  <div style={{ marginBottom: '12px' }}>
                    For any assistance please contact us via email at <SupportEmailLink /> or join our Discord channel:
                  </div>
                  <DiscordInviteButton />
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Application Method */}
        <div className={styles.methodSection}>
          <h2 className={styles.methodTitle}>Alternatively, you can also activate your key through the Epic games application. This is how you do it:</h2>
          <div className={styles.steps}>
            
            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>1</span>
              </div>
              <div className={styles.stepContent}>
                <h3 className={styles.stepTitle}>Launch Epic Games Application</h3>
                <div className={styles.stepDescription}>
                  Launch your Epic Games application.
                </div>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>2</span>
              </div>
              <div className={styles.stepContent}>
                <h3 className={styles.stepTitle}>Access Redeem Code</h3>
                <div className={styles.stepDescription}>
                  Click on your account name on the bottom left and then click <strong className={styles.boldText}>Redeem Code</strong>.
                </div>
                <div className={styles.stepImage}>
                  <img 
                    src={`${process.env.PUBLIC_URL}/images/activation-guides/epic-games-app-step-2.jpg`}
                    alt="Step 2: Click account name and Redeem Code"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.onerror = null;
                      target.style.display = 'none';
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>3</span>
              </div>
              <div className={styles.stepContent}>
                <h3 className={styles.stepTitle}>Enter Key and Redeem</h3>
                <div className={styles.stepDescription}>
                  In the page that shows up, enter your key and click <strong className={styles.boldText}>"REDEEM"</strong>.
                </div>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>
                <span>4</span>
              </div>
              <div className={styles.stepContent}>
                <h3 className={styles.stepTitle}>OnePlay Support</h3>
                <div className={styles.stepDescription}>
                  <div style={{ marginBottom: '12px' }}>
                    For any assistance please contact us via email at <SupportEmailLink /> or join our Discord channel:
                  </div>
                  <DiscordInviteButton />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* <div className={styles.additionalNotes}>
        <h3>Important Notes</h3>
        <ul>
          <li>Epic Games codes are region-specific and must match your account region</li>
          <li>Some games may require additional setup after activation</li>
          <li>Codes can only be used once and cannot be transferred between accounts</li>
        </ul>
      </div>

      <div className={styles.support}>
        <h3>Need More Help?</h3>
        <p>
          If you encounter any issues during the activation process, visit the official{' '}
          <a 
            href="https://www.epicgames.com/help/" 
            target="_blank" 
            rel="noopener noreferrer"
            className={styles.supportLink}
          >
            Epic Games Support Center
          </a>
          {' '}for additional assistance.
        </p>
      </div> */}
    </div>
  );
};

export default EpicGamesGuide; 